import { currencies, type SupportedCurrencies } from './currencies.ts';

export const getForcedCurrency = (
    urlSearchParams?: URLSearchParams
): SupportedCurrencies | undefined => {
    let currency = urlSearchParams?.get('currency');
    if (!currency && typeof window !== 'undefined') {
        currency = new URLSearchParams(window.location.search).get('currency');
    }
    currency = currency ? currency.toUpperCase() : '';
    if (currencies.includes(currency)) {
        return currency;
    }
    return undefined;
};
